import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Environment, EnvironmentService } from '@galaxy/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const SMB_SELF_SIGNUP_FEATURE_ID = 'smb_self_signup';

@Injectable()
export class FeatureFlagService {
  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  isSMBSelfSignupEnabled$(partner_id: string, market_id: string): Observable<boolean> {
    return this.isFeatureEnabled([SMB_SELF_SIGNUP_FEATURE_ID], partner_id, market_id);
  }

  private isFeatureEnabled(featureIds: string[], partnerId: string, marketId: string): Observable<boolean> {
    const url = `${this.host}/_ajax/v1/is-feature-enabled`;
    const params = { featureIds: featureIds, partnerId: partnerId, marketId: marketId };
    return this.http.post(url, params).pipe(
      map((result: any) => {
        const data = result.data || {};
        for (const featureId of featureIds) {
          if (data[featureId]) {
            return data[featureId] as boolean;
          }
        }
        return false;
      }),
    );
  }

  private get host(): string {
    switch (this.environmentService.getEnvironment()) {
      case Environment.TEST:
        return 'https://partner-central-test.appspot.com';
      case Environment.DEMO:
        return 'https://partner-central-demo.appspot.com';
      case Environment.PROD:
        return 'https://partner-central.appspot.com';
      default:
        return 'https://partner-central-test.appspot.com';
    }
  }
}
